module.exports = __webpack_public_path__ + "static/media/contract-book-pencil.ac88df8e.png";